import { useLayoutEffect, type RefObject } from "react";
import { useLocation } from "react-router-dom";

/** Scroll changes a CSS variable directly; no React render or scene recreation per frame. */
export function useBannerScrollFade(ref: RefObject<HTMLElement | null>) {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;
    const motion = matchMedia("(prefers-reduced-motion: reduce)");
    let frame = 0;
    let topbarHeight = document.querySelector(".topbar")?.getBoundingClientRect().height ?? 0;
    const draw = () => {
      frame = 0;
      const rect = element.getBoundingClientRect();
      const progress = motion.matches ? 0 : Math.min(1, Math.max(0, (topbarHeight - rect.top) / Math.max(1, rect.height * 0.85)));
      const eased = progress * progress * (3 - 2 * progress);
      element.style.setProperty("--section-banner-scroll-opacity", (1 - eased).toFixed(4));
    };
    const schedule = () => { if (!motion.matches && !frame) frame = requestAnimationFrame(draw); };
    const resize = () => { topbarHeight = document.querySelector(".topbar")?.getBoundingClientRect().height ?? 0; draw(); };
    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", resize, { passive: true });
    motion.addEventListener("change", draw);
    draw();
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("scroll", schedule);
      window.removeEventListener("resize", resize);
      motion.removeEventListener("change", draw);
      element.style.removeProperty("--section-banner-scroll-opacity");
    };
  }, [ref, pathname]);
}
